import { render, staticRenderFns } from "./TestEquipmentMain.vue?vue&type=template&id=501a8f4a"
import script from "./TestEquipmentMain.vue?vue&type=script&lang=ts"
export * from "./TestEquipmentMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports